import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DocSdk } from '../sdks/doc.sdk';
import { Collection } from '../models/ui/collection.model';
import { Document } from '../models/ui/document.model';
import { FiltersSdk } from '../sdks/filters.sdk';
import { Filter } from '../models/ui/filter.model';

/**
 * Manager responsible for returning one time stateless search queries.
 */
@Injectable({
	providedIn: 'root'
})
export class SearchManager {

	constructor(private docSdk: DocSdk, private filtersSdk: FiltersSdk) {

	}

	public search(params: DocumentSearchCommandParams): Observable<Collection<Document>> {
		return this.docSdk.search({
			top: params.take,
			searchTerm: params.documentTitle
		});
	}

	public createFilter(params: CreateFilterParams): Observable<Filter> {
		return this.filtersSdk.post({ filters: params.filters });
	}
}

interface SearchCommandParams {
	take: number;
}

interface DocumentSearchCommandParams extends SearchCommandParams {
	documentTitle: string;
}

interface CreateFilterParams {
	filters: any;
}
